import { Building2 } from 'lucide-react';
import { Badge } from '../ui/badge';
import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';

export const NO_DEPARTMENT = '__none__';
export const departmentLabel = (d) => (d === NO_DEPARTMENT ? 'No department' : d);

// "All departments" or "Selected departments" (+ which ones) for the Assign Users window
export const DepartmentScopePicker = ({ departments, scope, onScopeChange, chosen, onChosenChange }) => {
    const toggle = (d) => onChosenChange(chosen.includes(d) ? chosen.filter((x) => x !== d) : [...chosen, d]);
    const options = [...departments, NO_DEPARTMENT];
    return (
        <div className="space-y-3 rounded-lg border p-3" data-testid="assign-department-scope">
            <div className="flex items-center gap-2 text-sm font-medium">
                <Building2 className="h-4 w-4 text-muted-foreground" />Show users from
            </div>
            <RadioGroup value={scope} onValueChange={onScopeChange} className="flex flex-wrap gap-4">
                <div className="flex items-center gap-2">
                    <RadioGroupItem value="all" id="dept-scope-all" data-testid="assign-scope-all" />
                    <Label htmlFor="dept-scope-all" className="cursor-pointer">All departments</Label>
                </div>
                <div className="flex items-center gap-2">
                    <RadioGroupItem value="selected" id="dept-scope-selected" data-testid="assign-scope-selected" />
                    <Label htmlFor="dept-scope-selected" className="cursor-pointer">Selected departments</Label>
                </div>
            </RadioGroup>
            {scope === 'selected' && (
                <div className="flex flex-wrap gap-2" data-testid="assign-department-options">
                    {options.map((d) => (
                        <label key={d} className={`flex cursor-pointer items-center gap-2 rounded-full border px-3 py-1 text-sm transition-colors ${chosen.includes(d) ? 'border-primary bg-primary/10' : 'hover:bg-muted'}`}
                            data-testid={`assign-dept-${d === NO_DEPARTMENT ? 'none' : d.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
                            <Checkbox checked={chosen.includes(d)} onCheckedChange={() => toggle(d)} />
                            {departmentLabel(d)}
                        </label>
                    ))}
                    {chosen.length === 0 && <Badge variant="outline" className="text-amber-600">Pick at least one department</Badge>}
                </div>
            )}
        </div>
    );
};
